"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DescriptionInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
var _CollapseWrapper = require("./CollapseWrapper");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var DescriptionInfo = function DescriptionInfo(props) {
  var product = props.product;
  return /*#__PURE__*/_react.default.createElement(_CollapseWrapper.CollapseWrapper, {
    label: /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
      id: "Description"
    })
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, product.description)));
};
exports.DescriptionInfo = DescriptionInfo;